<template>
  <div>
    <section class="section max-w-800">
      <HeaderSection :title="$t('views.changePassword.title')"/>
      <div class="pa-30">
        <div class='forms row'>
          <VqInput
              classes="col-tab-6"
              :label="$t('views.changePassword.form.password')"
              name="password"
              type="password"
              :errors="errors.new_password1"
              v-model="formData.new_password1"
          />
          <VqInput
              classes="col-tab-6"
              :label="$t('views.changePassword.form.confirm')"
              name="confirm_password"
              type="password"
              :errors="errors.new_password2"
              v-model="formData.new_password2"
          />
        </div>

        <div class="group mt-20">
          <button
            type="button"
            class="button is-small is-gray-400"
            @click="cancel">{{ $t('views.changePassword.form.cancel') }}
          </button>
          <button
            type="button"
            class="button is-small is-gamma"
            @click="submit">{{ $t('views.changePassword.form.submit') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderSection from '@/components/HeaderSection.vue';
import VqInput from '@/components/VqInput.vue';

import AUTH from '@/api/auth';

export default {
  name: 'createPassword',
  components: {
    HeaderSection,
    VqInput,
  },
  data: () => ({
    formData: {},
    errors: {},
  }),
  computed: {
  },
  created() {
    this.passwordResetCheck();
  },
  mounted() {
  },
  methods: {
    passwordResetCheck() {
      AUTH.passwordResetCheck(this.$route.params).then(
        (res) => {
        },
        (err) => {
          this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
        },
      );
    },

    submit() {
      this.errors = {};
      this.formData = Object.assign(this.$route.params, this.formData);
      AUTH.passwordResetConfirm(this.formData).then(
        (res) => {
          this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },

    cancel() {
      this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
    },
  },
};
</script>
